import classes from "./Ripple.module.css";

const Ripple = ({ className }) => {
  return (
    <div className={classes.Ripple}>
      <div className={`border-4 ${className}`}></div>
      <div className={`border-4 ${className}`}></div>
    </div>
  );
};

export default Ripple;
